import { Suspense, lazy } from 'react';
import { useUpdateLiveData } from '../../interpreter/hooks/useUpdateLiveData';
import useSoundManager from '../../interpreter/hooks/useSoundManager';
import WaitingScreen from '../../components/waiting_screen';
import { HudManager } from '../../app/hud/hud_manager';
import { AutonomousStop } from '../../components/autonomousStop';
import { AutonomousWidgetManager } from '../../app/widget/autonomousWidgetManager';
import { useVersionStore } from '../../store/sceneStore';

const MapViewWrapper = lazy(() => import('../../app/map_view/mapViewWrapper'));

const LoadingFallback = () => (
	<div className='flex h-full items-center justify-center text-2xl font-bold'>
		Loading Map...
	</div>
);

export const DeveloperPage = () => {
	const version = useVersionStore();

	useUpdateLiveData();
	useSoundManager();

	if (!version.accepted) {
		return <WaitingScreen waitingText={'waiting for connection...'} />;
	}

	return (
		<>
			<Suspense fallback={<LoadingFallback />}>
				<MapViewWrapper />
			</Suspense>
			<HudManager />
			<AutonomousWidgetManager />
			<AutonomousStop />
		</>
	);
};
